import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { RestBuilder } from '../helpers/rest.builder';
import { IPackage, IPackageAddon } from '../../../../shared/interfaces/packaging.interface';

@Injectable({ providedIn: 'root' })
export class PackageApi {
  private restBuilder: RestBuilder;

  constructor(private httpClient: HttpClient) {
    this.restBuilder = new RestBuilder();
  }

  // GET /admin/packages
  public getPackages(): Observable<IPackage[]> {
    const url: string = this.restBuilder.create().admin().packages().getApiUrl();
    return this.httpClient.get<IPackage[]>(url);
  }

  // GET /admin/packages/userway
  public getUserWayPackages(): Observable<IPackage[]> {
    const url: string = this.restBuilder.create().admin().packages().userway().getApiUrl();
    return this.httpClient.get<IPackage[]>(url);
  }

  // GET /admin/packages/packageAddons
  public getPackageAddons(forPackage: string): Observable<IPackageAddon[]> {
    const url: string = this.restBuilder.create().admin().packages(forPackage).packageAddons().getApiUrl();
    return this.httpClient.get<IPackageAddon[]>(url);
  }
}
